<template>
  <v-container>
    <v-card class="pa-6">
      <v-card-title class="text-h5">📘 Help & User Guide</v-card-title>

      <v-divider class="my-4" />

      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1">🎉 What is this system?</v-list-item-title>
            <v-list-item-subtitle>
              This is an Event Management Dashboard where you can manage events, attendees, and track check-ins.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1">➕ Adding Events</v-list-item-title>
            <v-list-item-subtitle>
              Go to the "Events" section and click <strong>Add Event</strong> to create a new event. Fill in the event name, description, date, and image.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1">👥 Managing Attendees</v-list-item-title>
            <v-list-item-subtitle>
              You can view, edit, or delete attendees in the "Attendees" tab. Use the edit icon ✏️ to modify their check-in status.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1">✅ Check-In System</v-list-item-title>
            <v-list-item-subtitle>
              When an attendee arrives, scan their QR code or update their status using the dashboard to mark them as checked-in.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1">📊 Dashboard Stats</v-list-item-title>
            <v-list-item-subtitle>
              The dashboard shows total attendees, check-in rates, top events, and upcoming schedules. Click on events for detailed views.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1">🛠 Troubleshooting</v-list-item-title>
            <v-list-item-subtitle>
              - Ensure the server is running at <code>http://events.bachirsouldi.com</code>.<br>
              - Check console for CORS or connection errors.<br>
              - Make sure the database is seeded with events and attendees.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-4" />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1">📩 Still need help?</v-list-item-title>
            <v-list-item-subtitle>
              Contact your admin or developer at <a href=""></a>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-container>
</template>
